/* FTT staple product page.
   Colourway image swap, gallery views, size-table units.
   Variant matching for the cart stays with ftt-reflective-tee.js,
   which already owns the shared picker and the hidden id field.

   Note: option positions are read with getAttribute rather than an
   attribute selector. [data-ftt-position=1] is invalid CSS — a bare
   digit is not a valid identifier — and querySelector throws on it. */
(function () {
  'use strict';

  function positionValue(root, pos) {
    var ins = root.querySelectorAll('[data-ftt-option-input]');
    for (var i = 0; i < ins.length; i++) {
      if (ins[i].checked && ins[i].getAttribute('data-ftt-position') === String(pos)) {
        return ins[i].value;
      }
    }
    var locks = root.querySelectorAll('[data-ftt-locked-option]');
    for (var j = 0; j < locks.length; j++) {
      if (locks[j].getAttribute('data-ftt-position') === String(pos)) {
        return locks[j].getAttribute('data-ftt-value');
      }
    }
    return null;
  }

  function init(root) {
    var plate = root.querySelector('[data-ftt-plate]');
    if (!plate) return;

    var img = plate.querySelector('[data-ftt-plate-img]');
    var inner = plate.querySelector('[data-ftt-plate-inner]');
    var thumbs = root.querySelector('[data-ftt-plate-thumbs]');
    if (!img || !inner) return;

    var view = 'variant';
    var variants = [];
    try {
      variants = JSON.parse(root.querySelector('[data-ftt-variants]').textContent);
    } catch (e) { variants = []; }

    /* Colour then logo fires two swaps back to back. Without a token the
       first preload can resolve last and paint the stale garment. */
    var token = 0;
    function swapTo(src, alt, editorial) {
      if (!src) return;
      var mine = ++token;
      img.classList.add('is-swapping');
      var next = new Image();
      next.onload = next.onerror = function () {
        if (mine !== token) return;
        img.src = src;
        if (alt) img.alt = alt;
        inner.classList.toggle('is-editorial', !!editorial);
        img.classList.remove('is-swapping');
      };
      next.src = src;
    }

    /* Colour plus logo identifies the garment shot on its own — size never
       changes the photo, so the image updates before a size is chosen. */
    function garment() {
      var a = positionValue(root, 1);
      var b = positionValue(root, 2);
      if (a === null && b === null) return null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if ((a === null || v.option1 === a) && (b === null || v.option2 === b)) return v;
      }
      return null;
    }

    function sized(url, w) {
      if (!url) return null;
      var abs = url.indexOf('//') === 0 ? window.location.protocol + url : url;
      return abs.indexOf('?') > -1 ? abs + '&width=' + w : abs + '?width=' + w;
    }

    function refresh() {
      if (view !== 'variant') return;
      var v = garment();
      if (!v || !v.featured_image) return;
      var parts = [positionValue(root, 1), positionValue(root, 2)];
      var label = [];
      for (var i = 0; i < parts.length; i++) { if (parts[i]) label.push(parts[i]); }
      swapTo(sized(v.featured_image.src, 1000), label.join(' / ') + ' Silicone Box Logo Tee', false);
      if (thumbs) {
        var t = thumbs.querySelector('button[data-view] img');
        if (t) t.src = sized(v.featured_image.src, 140);
      }
    }

    root.addEventListener('change', function (e) {
      if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-ftt-option-input')) {
        refresh();
      }
    });

    if (thumbs) {
      thumbs.addEventListener('click', function (e) {
        var b = e.target.closest('button');
        if (!b) return;
        view = b.getAttribute('data-view');
        var all = thumbs.querySelectorAll('button');
        for (var i = 0; i < all.length; i++) {
          all[i].setAttribute('aria-current', String(all[i] === b));
        }
        if (view === 'variant') { refresh(); return; }
        swapTo(sized(b.getAttribute('data-src'), 1000), b.getAttribute('data-alt'), true);
      });
    }

    refresh();
  }

  /* Size table units. Both sets are published on the supplier chart —
     converting on the fly disagrees with their own rounding. */
  function units(root) {
    var box = root.querySelector('[data-ftt-units]');
    if (!box) return;
    box.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b) return;
      var unit = b.getAttribute('data-unit');
      var btns = box.querySelectorAll('button');
      for (var i = 0; i < btns.length; i++) {
        btns[i].setAttribute('aria-pressed', String(btns[i] === b));
      }
      var cells = root.querySelectorAll('[data-cm]');
      for (var j = 0; j < cells.length; j++) {
        var val = cells[j].getAttribute('data-' + unit);
        if (val) cells[j].textContent = val;
      }
    });
  }

  function boot() {
    var roots = document.querySelectorAll('[data-ftt-staple]');
    for (var i = 0; i < roots.length; i++) {
      /* isolated so a failure in one never blocks the other */
      try { init(roots[i]); } catch (e) {}
      try { units(roots[i]); } catch (e) {}
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
